 import React from 'react'

 class Sroce extends React.Component{




        

    render(){
         return(
             <div className='timer' >
      <p className='word'>Sorce</p>
       
             {this.props.value}
             </div>
         )
     }
 }

export default Sroce;